<template>
  <div class="application_form_box">
    <template v-if="isShowBtn">
      <div class="query_wapper" style="margin-bottom:30px">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
        <el-select
          :popper-append-to-body="false"
          style="margin:0 20px;width:200px;"
          v-model="headValue.year"
          @change="getMatch"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          style="width:220px"
          :popper-append-to-body="false"
          v-model="headValue.matchName"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
        <el-button
          style="width:90px;margin:0 10px 0 20px;"
          v-if="false"
          @click="print"
          type="warning"
        >打印</el-button>
        <el-button style="width:90px" type="primary" v-if="false" @click="exportPdf">导出</el-button>
      </div>
      <template v-if="switchType === 1">
        <el-form :model="query" ref="form" :rules="rules" label-width="80px">
          <el-row>
            <el-col :span="16">
              <el-form-item label="赛事名称" prop="raceName">
                <el-select
                  disabled
                  :popper-append-to-body="false"
                  style="width:592px"
                  v-model="query.raceName"
                  placeholder="请选择赛事"
                >
                  <el-option
                    v-for="(item,index) in matchList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="校名">
                <el-input
                  disabled
                  v-model="query.schoolName"
                  style="width:200px"
                  placeholder="请输入学校名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="组别" prop="groupId">
                <el-select
                  disabled
                  :popper-append-to-body="false"
                  style="width:200px"
                  v-model="query.groupId"
                >
                  <el-option
                    v-for="(item,index) in signGroup"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="领队" prop="leaderName">
                <el-input
                  v-model="query.leaderName"
                  disabled
                  style="width:200px"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机" prop="leaderPhone">
                <el-input
                  v-model="query.leaderPhone"
                  disabled
                  style="width:200px"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮箱" prop="leaderEmail">
                <el-input
                  v-model="query.leaderEmail"
                  disabled
                  style="width:200px"
                  placeholder="非必填项"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="主教练">
                <el-select
                  clearable
                  disabled
                  :popper-append-to-body="false"
                  style="width:200px"
                  v-model="query.headCoachId"
                  placeholder="请选择主教练"
                >
                  <el-option
                    v-for="(item,index) in coachList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机">
                <el-input
                  disabled
                  v-model="query.headCoachPhone"
                  style="width:200px"
                  placeholder="自动匹配"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮箱" prop="headCoachEmail">
                <el-input
                  disabled
                  v-model="query.headCoachEmail"
                  style="width:200px"
                  placeholder="非必填项"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="教练员">
                <el-select
                  disabled
                  :popper-append-to-body="false"
                  style="width:200px"
                  v-model="query.coachIds"
                  multiple
                  placeholder="请选择教练员"
                >
                  <el-option
                    v-for="(item,index) in otherCoachList"
                    :key="index"
                    :disabled="item.disabled"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作人员">
                <el-input
                  style="width:200px"
                  disabled
                  v-model="query.workerNames"
                  placeholder="请输入工作人员姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="住宿">
                <el-row>
                  <el-col :span="8.5">
                    <span>男</span>
                    <el-input disabled v-model="query.stayMan" style="width:60px;margin:0 8px"></el-input>
                    <span>，</span>
                  </el-col>
                  <el-col :span="12">
                    <span style="margin-right:8px">女</span>
                    <el-input disabled v-model="query.stayWoman" style="width:60px"></el-input>
                    <span>（人）</span>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table style="width:100%;margin-top:40px" border :data="tableData">
          <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
          <el-table-column label="姓名" :min-width="query.groupId?150:200" align="center" prop="name"></el-table-column>
          <el-table-column label="性别" min-width="100" align="center" prop="genderText"></el-table-column>
          <el-table-column label="学号" min-width="100" align="center" prop="studentNumber"></el-table-column>
          <el-table-column label="入学时间" min-width="100" align="center" prop="startSchoolDateText"></el-table-column>
          <el-table-column label="注册号码" min-width="100" align="center" prop="registerNumber"></el-table-column>
          <el-table-column label="电话号码" min-width="120" align="center" prop="phone"></el-table-column>
          <el-table-column label="团体" width="110" align="center" prop="smallBallGroup"></el-table-column>
          <el-table-column label="男单" width="110" align="center" prop="smallBallSingles1"></el-table-column>
          <el-table-column label="女单" width="110" align="center" prop="smallBallSingles0"></el-table-column>
          <el-table-column label="男双" width="110" align="center" prop="smallBallDoubles1"></el-table-column>
          <el-table-column label="女双" width="110" align="center" prop="smallBallDoubles0"></el-table-column>
          <el-table-column label="混双" width="110" align="center" prop="smallBallMixed"></el-table-column>
        </el-table>
        <footer v-if="reviewState === 1">
          <el-button
            :loading="loadingData.submitLoading"
            class="btns"
            style="width:90px"
            @click="operation('agree')"
          >同意</el-button>
          <el-button
            @click="operation('reject')"
            :loading="loadingData.saveLoading"
            class="btns"
            style="margin:0 20px;width:90px"
          >驳回</el-button>
        </footer>
        <footer v-else>
          <span style="font-size:22px">审核状态：</span>
          <span
            :style="{color:reviewState === 0?'#1E63B0':reviewState === 2?'#FD6666':'#1CC28C'}"
            style="font-size:18px"
          >{{reviewState === 0?'报名未提交':reviewState === 2?'审核未通过':'审核已通过'}}</span>
        </footer>
      </template>
      <athletesPhoto v-else :details="details"></athletesPhoto>
      <div id="listPrint" style="position:absolute;left:-50000px;top:-10000px">
        <listPrint ref="listPrint" :info="printInfo" :matchList="matchList"></listPrint>
      </div>
    </template>
    <template v-else>
      <div class="query_wapper">
        <el-select
          :popper-append-to-body="false"
          style="margin:0 20px;"
          v-model="headValue.year"
          @change="getMatch"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          :popper-append-to-body="false"
          v-model="headValue.matchName"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
      </div>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  addSign,
  updateSign,
  signDetail,
  getSignListBySchool,
  schoolAudit
} from "@/api/sign-up-match";
import listPrint from "@/components/list-print";
import athletesPhoto from "./components/athletes-photo";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import registerData from "@/assets/json/register.json";
import { table, message,selectiveYear } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { rule } from "@/utils/utils";
export default {
  mixins: [table, message,selectiveYear],
  components: {
    athletesPhoto,
    listPrint
  },
  // 报名表填写
  data() {
    return {
      switchType: 1,
      hideMask: false,
      isShowBtn: true,
      reviewState: 1,
      details: {},
      coachList: [],
      currentProject: {},
      athleteList: [],
      headValue: {
        year: "",
        matchName: ""
      },
      printInfo: {
        id: "",
        year: "",
        project: ""
      },
      matchList: [],
      query: {
        id: "",
        raceName: "",
        matchId: "",
        leaderName: "",
        leaderPhone: "",
        leaderEmail: "",
        headCoachId: "",
        headCoachName: "",
        headCoachPhone: "",
        headCoachEmail: "",
        schoolName: JSON.parse(getSession("userInfo")).schoolName,
        groupId: "",
        coachIds: [],
        coachNames: "",
        workerNames: "",
        stayMan: "",
        stayWoman: ""
      },
      titles: ["name", "number", "position", "remarks"],
      editable: [],
      otherCoachList: [],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      rules: {
        leaderName: [
          {
            required: true,
            message: "领队姓名不能为空",
            trigger: "blur"
          }
        ],
        leaderPhone: [
          { required: true, validator: rule.phone, trigger: "blur" }
        ],
        leaderEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachId: [
          {
            required: true,
            message: "主教练不能为空",
            trigger: "change"
          }
        ],
        groupId: [
          {
            required: true,
            message: "组别不能为空",
            trigger: "change"
          }
        ],
        coachIds: [
          {
            required: true,
            message: "教练员不能为空",
            trigger: "change"
          }
        ],
        workerNames: [
          {
            required: true,
            message: "工作人员姓名不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    signGroup() {
      return registerData.registGroup;
    }
  },
  methods: {
    // 调用打印功能
    print() {
      this.$nextTick(() => {
        Object.assign(this.printInfo, {
          id: this.headValue.matchName,
          year: this.headValue.year,
          project: 1
        });
      });
      let interval = setInterval(() => {
        if (this.$refs.listPrint.isRender) {
          clearInterval(interval);
          this.$refs.listPrint.print();
        }
      }, 300);
    },
    // 导出pdf
    exportPdf() {
      this.$nextTick(() => {
        Object.assign(this.printInfo, {
          id: this.headValue.matchName,
          year: this.headValue.year,
          project: 1
        });
      });
      let interval = setInterval(() => {
        if (this.$refs.listPrint.isRender) {
          clearInterval(interval);
          this.$refs.listPrint.exportPdf();
        }
      }, 300);
    },
    // 切换按钮组
    selectType(type) {
      this.switchType = type;
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 1,
        year: this.headValue.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            this.headValue.matchName = res[0].id;
            this.isShowBtn = true;
            this.makeTable(res[0].count);
            this.getSignDetail(res[0].id);
          } else {
            this.matchList = [];
            this.headValue.matchName = "";
            this.isShowBtn = false;
            this.details = {};
          }
          this.hideMask = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 生成表格
    makeTable(count) {
      this.tableData = [];
      for (let i = 0; i < count; i++) {
        this.tableData.push({
          name: "",
          genderText: "",
          registerNumber: "",
          athleteId: "",
          studentNumber: "",
          startSchoolDateText: "",
          phone: "",
          smallBallGroup: "",
          smallBallSingles1: "",
          smallBallSingles0: "",
          smallBallDoubles1: "",
          smallBallDoubles0: "",
          smallBallMixed: ""
        });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    //   同意驳回
    operation(type) {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.headValue.matchName) id = item.matchId;
      });

      if (type === "agree") this.loadingData.submitLoading = true;
      else this.loadingData.saveLoading = true;
      schoolAudit({
        id: this.query.id,
        state: type === "agree" ? 3 : 2
      })
        .then(res => {
          this.openSuccess(type === "agree" ? "审核成功！" : "驳回成功！");
          if (type === "agree") this.loadingData.submitLoading = false;
          else this.loadingData.saveLoading = false;
          this.$router.push({
            path: "/tennis/tennis-registration-form-view",
            query: {
              id,
              year: this.headValue.year
            }
          });
        })
        .catch(err => {
          if (type === "agree") this.loadingData.submitLoading = false;
          else this.loadingData.saveLoading = false;
        });
    },
    // 选择运动员
    selectAthlete(value, num, col) {
      this.athleteList.filter((item, index) => {
        if (item.id === value) {
          this.$set(this.athleteList[index], "disabled", true);
          for (let temp in item) {
            if (this.tableData[num].hasOwnProperty(temp)) {
              this.$set(this.tableData[num], temp, item[temp]);
            }
            this.$set(this.tableData[num], "athleteId", value);
          }
        }
      });

      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
          this.otherCoachList = [...res];
        })
        .catch(err => {});
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          effective: 1,
          pageSize: 999,
          groupId: this.query.groupId,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则且状态为0，则表示为草稿箱数据
    getSignDetail(id) {
      signDetail({ project: 1, id })
        .then(res => {
          this.makeTable(res.count);
          this.details = res;
          this.reviewState = res.state;
          Object.assign(this.query, {
            raceName: res.matchName,
            workerNames: res.workerNames,
            groupId: res.groupId,
            leaderName: res.leaderName,
            leaderPhone: res.leaderPhone,
            leaderEmail: res.leaderEmail,
            headCoachEmail: res.headCoachEmail,
            headCoachId: res.headCoachId,
            headCoachPhone: res.headCoachPhone,
            headCoachName: res.headCoachName,
            stayWoman: res.stayWoman,
            stayMan: res.stayMan,
            coachIds: !res.coachIds ? [] : res.coachIds.split(","),
            id: res.id
          });
          this.getAthleteListByDraft()
            .then(data => {
              this.athleteList = [...data.list];
              res.athleteList.filter((item, index) => {
                Object.assign(this.tableData[index], {
                  name: item.athleteName,
                  smallBallGroup: item.projectJson.smallBallGroup,
                  smallBallSingles1: item.projectJson.smallBallSingles1,
                  smallBallSingles0: item.projectJson.smallBallSingles0,
                  smallBallDoubles1: item.projectJson.smallBallDoubles1,
                  smallBallDoubles0: item.projectJson.smallBallDoubles0,
                  smallBallMixed: item.projectJson.smallBallMixed
                });
                this.selectAthlete(item.athleteId, index, "name");
              });
            })
            .catch(err => {});
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getYearLists(this.headValue, this.getMatch);
    this.getCoachLists();
  }
};
</script>
<style lang="less" scoped>
.application_form_box {
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #333;
  }
  .application_form {
    > li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      > p {
        display: flex;
        align-items: center;
        margin-right: 120px;
        .basics {
          width: 70px;
          margin-right: 10px;
          text-align: right;
        }
      }
    }
  }
  .table_select_box {
    /deep/ .el-input__inner {
      line-height: 30px;
      height: 30px;
    }
    /deep/ .el-input__icon {
      line-height: 30px;
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
}
</style>